module.exports = __webpack_public_path__ + "img/play_icon.c3577540.png";